import { parseExpression_Normalized } from './parser.js';
import { StaticLogger } from '@nu-art/ts-common';
export function getParsedExpressionIds(expression) {
    const result = [];
    if (expression.expression.trim() === 'true')
        return result;
    try {
        const parsed = parseExpression_Normalized(expression.expression);
        collectRefs(parsed, expression, result);
        return result;
    }
    catch (e) {
        StaticLogger.logError('getParsedExpressionIds', `Failed to parse expression with id ${expression._id}`);
        return result;
    }
}
function collectRefs(node, expression, result) {
    switch (node.type) {
        case 'term': {
            const term = expression.terms[node.termIndex - 1];
            if (term)
                collectRefsForTerm(term, result);
            return;
        }
        case 'atom':
        case 'number':
            return;
        case 'unary':
            collectRefs(node.operand, expression, result);
            return;
        case 'binary':
        case 'comparison':
            collectRefs(node.leftHand, expression, result);
            collectRefs(node.rightHand, expression, result);
            return;
        case 'variadic':
            for (const operand of node.operands)
                collectRefs(operand, expression, result);
            return;
        case 'group':
            collectRefs(node.expression, expression, result);
            return;
        case 'range':
            collectRefs(node.min, expression, result);
            collectRefs(node.max, expression, result);
            return;
    }
}
export function collectRefsForTerm(term, result) {
    if (hasSubTerms(term))
        collectSubTermRefs(term, result);
    else
        collectTermAtomRefs(term.expression, term.atoms, undefined, result);
}
function hasSubTerms(term) {
    return 'subTerms' in term && Array.isArray(term.subTerms);
}
function collectSubTermRefs(term, result) {
    // The parent term's expression references atoms (A1, A2...) which map to sub-terms
    // Each sub-term's atoms can reference parent atoms via leftHand.type === 'atom'
    let parsed;
    try {
        parsed = parseExpression_Normalized(term.expression);
    }
    catch {
        for (const subTerm of term.subTerms)
            collectTermAtomRefs(subTerm.expression, subTerm.atoms, term.atoms, result);
        return;
    }
    collectSubTermAtomRefs(parsed, term, result);
}
function collectSubTermAtomRefs(node, term, result) {
    switch (node.type) {
        case 'atom': {
            // Each "atom" in the parent term expression corresponds to a sub-term
            const subTerm = term.subTerms[node.atomIndex - 1];
            if (subTerm)
                collectTermAtomRefs(subTerm.expression, subTerm.atoms, term.atoms, result);
            return;
        }
        case 'term':
        case 'number':
            return;
        case 'unary':
            collectSubTermAtomRefs(node.operand, term, result);
            return;
        case 'binary':
        case 'comparison':
            collectSubTermAtomRefs(node.leftHand, term, result);
            collectSubTermAtomRefs(node.rightHand, term, result);
            return;
        case 'variadic':
            for (const operand of node.operands)
                collectSubTermAtomRefs(operand, term, result);
            return;
        case 'group':
            collectSubTermAtomRefs(node.expression, term, result);
            return;
        case 'range':
            collectSubTermAtomRefs(node.min, term, result);
            collectSubTermAtomRefs(node.max, term, result);
            return;
    }
}
function collectTermAtomRefs(termExpression, atoms, parentAtoms, result) {
    let parsed;
    try {
        parsed = parseExpression_Normalized(termExpression);
    }
    catch {
        // If the term expression can't be parsed, fall back to array order
        for (const atom of atoms)
            addAtomRef(atom, parentAtoms, result);
        return;
    }
    collectAtomRefs(parsed, atoms, parentAtoms, result);
}
function collectAtomRefs(node, atoms, parentAtoms, result) {
    switch (node.type) {
        case 'atom': {
            const atom = atoms[node.atomIndex - 1];
            if (atom)
                addAtomRef(atom, parentAtoms, result);
            return;
        }
        case 'term':
        case 'number':
            return;
        case 'unary':
            collectAtomRefs(node.operand, atoms, parentAtoms, result);
            return;
        case 'binary':
        case 'comparison':
            collectAtomRefs(node.leftHand, atoms, parentAtoms, result);
            collectAtomRefs(node.rightHand, atoms, parentAtoms, result);
            return;
        case 'variadic':
            for (const operand of node.operands)
                collectAtomRefs(operand, atoms, parentAtoms, result);
            return;
        case 'group':
            collectAtomRefs(node.expression, atoms, parentAtoms, result);
            return;
        case 'range':
            collectAtomRefs(node.min, atoms, parentAtoms, result);
            collectAtomRefs(node.max, atoms, parentAtoms, result);
            return;
    }
}
function addAtomRef(atom, parentAtoms, result) {
    if (!atom.leftHand)
        return;
    if (atom.leftHand.type === 'variable' || atom.leftHand.type === 'expression') {
        result.push({ id: atom.leftHand.id, type: atom.leftHand.type });
        return;
    }
    // type === 'atom': resolve through parent term's atoms
    if (atom.leftHand.type === 'atom' && parentAtoms) {
        const parentAtom = parentAtoms[Number(atom.leftHand.id)];
        if (parentAtom)
            addAtomRef(parentAtom, undefined, result);
    }
}
//# sourceMappingURL=get-ids.js.map